
export default {
  name: 'ButtonIcon',
  props: {
    href: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'gold', // gold white gray black coffe
    },
    size: {
      type: String,
      default: 'md', // md lg
    },
    icon: {
      type: String,
      default: null, // pencil book minus plus
    },
    text: {
      type: String,
      default: null, //
    },
    disabled: {
      type: Boolean,
      default: false, // true false
    },
    isActive: {
      type: Boolean,
      default: false, // true false
    },
  },
}
